// ADR 16.9.26p §3 — resume: the persist string in `localStorage`, the phones'
// SharedPreferences (`walkthrough_progress:{planId}` on Android).
//
// The blob is `rust-core`'s own `persist_string()` — versioned JSON the
// constructor restores tolerantly (corrupt, stale or drifted → clamped or
// fresh, never a throw) — so nothing here parses it. Wrapped in `try/catch`
// like every other store in the client: a private window renders page 0.

const PREFIX = 'lingara.walkthrough.'

export function readProgress(planId: string): string | null {
  try {
    return window.localStorage.getItem(`${PREFIX}${planId}`)
  } catch {
    return null
  }
}

export function writeProgress(planId: string, blob: string): void {
  try {
    window.localStorage.setItem(`${PREFIX}${planId}`, blob)
  } catch {
    // Nothing to do: the session still pages for as long as it is mounted.
  }
}

/**
 * ADR 24.9.26h §4 — forget every plan's position on sign-out. The keys name
 * the departing learner's plan ids, and a shared browser's next user should
 * not inherit them. Keys are collected before removal because removing while
 * indexing shifts `Storage.key(i)`.
 */
export function clearWalkthroughProgress(): void {
  try {
    const storage = window.localStorage
    const keys: string[] = []
    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i)
      if (key?.startsWith(PREFIX)) keys.push(key)
    }
    for (const key of keys) storage.removeItem(key)
  } catch {
    // A private window that refused the read has nothing of ours to forget.
  }
}
